// Copyright 2026. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';

export const VerticalIndent = styled.div`
    margin-top: 24px;
`;
